import { HttpErrorResponse } from '@angular/common/http';
import { truncateMessage } from '@common/utils';
import { I18NextPipe } from 'angular-i18next';

export function getLoginErrorText(res: HttpErrorResponse, i18nPipe: I18NextPipe): string {
  if (!res) return '';

  const { error, status } = res || {};

  if (status === 503 || status === 500) {
    return i18nPipe.transform('common.unavailableService', { format: 'capitalize' });
  }

  if (status === 440) {
    return error?.message || i18nPipe.transform('common.somethingWrong', { format: 'capitalize' });
  }

  return truncateMessage(error?.value || error?.error?.message || i18nPipe.transform('common.somethingWrong', { format: 'capitalize' }));
}
